/* eslint max-classes-per-file: 0 */

import {
  Mark as Data,
  MarkCollection as Collection,
} from '@/typings/api/Marks'

import { BaseMarksApiAuth } from '@/api/BaseApiAuth'
import {
  BaseApiResponse,
} from '@/typings/common'
import { AxiosRequestConfig } from 'axios'

export class QuestionsApi extends BaseMarksApiAuth<Data, Collection> {
  protected readonly endpoint = 'questions';

  protected readonly hasFinishSlash = false;

  public positions(procedure_id: string, config?: AxiosRequestConfig) {
    const path = 'positions'
    const [url] = this.getUrl(path)
    const data = { procedure_id }
    return this.request<never, BaseApiResponse<{ data: Array<number> }, never>>(
      'POST',
      url,
      { data, ...config },
    )
  }
}
